export interface MmiElocDetails {
  eloc: string;
  latitude: number;
  longitude: number;
}
